import { ITEM_TYPE } from '@/utils/enum';
import { roundMoneyToThousand } from '@/utils/voucherDiscountStack';

/** R29: tổng bill sau CK program, có trừ voucher trên giỏ */
export function calculateRetailBillTotalAmount(billItems = []) {
  let total = 0;
  (billItems || []).forEach((line) => {
    if (Number(line.itemType) !== ITEM_TYPE.MAIN || line.belongBillDetailId) {
      return;
    }
    const unit = Number(line.sellingPriceMask ?? line.sellingPrice ?? line.productPrice ?? 0);
    const qty = Number(line.quantity ?? 1) || 1;
    const program = Number(line.discountProgramAmount ?? 0) || 0;
    const voucher = Number(line.voucherAmount ?? 0) || 0;
    total += unit * qty - program - voucher;
  });
  return roundMoneyToThousand(total);
}

export function hydrateLineVouchersFromApi(line) {
  if (Array.isArray(line.vouchers) && line.vouchers.length) {
    line.vouchers = line.vouchers.map((entry, index) => ({
      voucherId: entry.voucherId,
      voucherDetailId: entry.voucherDetailId,
      voucherCode: entry.voucherCode || entry.code,
      voucherAmount: Number(entry.voucherAmount ?? entry.discountAmount ?? 0),
      name: entry.name || '',
      sortOrder: entry.sortOrder != null ? entry.sortOrder : index,
    }));
    return line.vouchers;
  }
  if (line.voucherCode || line.voucherDetailId) {
    line.vouchers = [
      {
        voucherId: line.voucherId,
        voucherDetailId: line.voucherDetailId,
        voucherCode: line.voucherCode,
        voucherAmount: Number(line.voucherAmount ?? 0),
        name: '',
        sortOrder: 0,
      },
    ];
    return line.vouchers;
  }
  line.vouchers = [];
  return line.vouchers;
}

export function syncLegacyVoucherFieldsFromArray(line) {
  const sorted = [...(line.vouchers || [])].sort(
    (a, b) => Number(a.sortOrder ?? 0) - Number(b.sortOrder ?? 0),
  );
  const primary = sorted[0] || null;
  const total = sorted.reduce((sum, entry) => sum + (Number(entry.voucherAmount) || 0), 0);
  line.voucherId = primary ? primary.voucherId : null;
  line.voucherDetailId = primary ? primary.voucherDetailId : null;
  line.voucherCode = primary ? primary.voucherCode : '';
  line.voucherAmount = total;
  return line;
}

export function buildVouchersPayload(line) {
  hydrateLineVouchersFromApi(line);
  return (line.vouchers || [])
    .filter((entry) => entry && String(entry.voucherCode || '').trim())
    .map((entry, index) => ({
      voucherId: entry.voucherId,
      voucherDetailId: entry.voucherDetailId,
      voucherCode: String(entry.voucherCode).trim(),
      voucherAmount: Number(entry.voucherAmount ?? 0),
      sortOrder: entry.sortOrder != null ? entry.sortOrder : index,
    }));
}

/** Read-only — không gọi hydrateLineVouchersFromApi (tránh mutate trong computed). */
export function countLineVouchersReadOnly(line) {
  if (Array.isArray(line?.vouchers) && line.vouchers.length) {
    return line.vouchers.filter(
      (entry) => entry && String(entry.voucherCode || '').trim(),
    ).length;
  }
  if (line?.voucherCode || line?.voucherDetailId) {
    return 1;
  }
  return 0;
}

export function lineHasMultiVoucherPayload(line) {
  return countLineVouchersReadOnly(line) > 1;
}

export function billHasMultiVoucherLines(billItems = []) {
  return (billItems || []).some((line) => lineHasMultiVoucherPayload(line));
}
